var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBylineIcon10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 35,
    viewBox: "0 0 21 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 8.16667,
    r: 8.16667,
    fill: "#383765"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6915 12.4443C21.4423 12.4443 21.7179 25.4073 20.5119 31.8888C20.1191 34 15.0915 35 10.6915 35C5.19149 35 0.690911 34 0.354193 31.8888C-0.679536 25.4073 -0.0592985 12.4443 10.6915 12.4443Z",
    fill: "#383765"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBylineIcon10);
export default __webpack_public_path__ + "static/media/BylineIcon10.8edc7eb3efa681b2778beb9ec29b0871.svg";
export { ForwardRef as ReactComponent };